import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <p>
        <small>Copyright &copy; Elias Norrby 2019</small>
      </p>
    </div>
  );
};

export default Footer;
